import React from 'react'

import Icon from '@scoir/components-core/dist/components/Icon'
import searchIcon from 'icons/search.svg'
import { constant, first, isEmpty, trimStart } from 'lodash'
import PropTypes from 'prop-types'
import { AsyncTypeahead, Menu, MenuItem } from 'react-bootstrap-typeahead'

import './index.scss'

class SearchBox extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    labelKey: PropTypes.string.isRequired,
    renderMenu: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  }
  static defaultProps = {
    placeholder: 'Search by name',
  }
  _typeahead = React.createRef()

  onSearch(newValue) {
    const trimmedValue = trimStart(newValue)
    if (trimmedValue.length > 0) {
      this.props.onSearch(trimmedValue)
    }
  }
  render() {
    return (
      <div className="search-box-comp">
        <AsyncTypeahead
          ref={this._typeahead}
          id="pfc-search-box"
          bsSize="sm"
          options={this.props.options}
          labelKey={this.props.labelKey}
          align="right"
          isLoading={false}
          minLength={1}
          filterBy={constant(true)}
          onSearch={(value) => this.onSearch(value)}
          inputProps={{ className: 'header-search-input' }}
          placeholder={this.props.placeholder}
          useCache={false}
          onChange={(val) => {
            if (!isEmpty(val)) {
              this._typeahead.current.getInstance().clear()
              this.props.onSelect(first(val))
            }
          }}
          renderMenu={(results, menuProps) => (isEmpty(results) ? null : this.props.renderMenu(results, menuProps))}
        />
        <Icon
          className="search-icon"
          def={searchIcon}
        />
      </div>
    )
  }
}

SearchBox.Menu = Menu
SearchBox.MenuItem = MenuItem
export default SearchBox
